export default {"src":"/_next/static/media/hand-drawn-nft-style-ape-illustration.b875bff2.svg","height":280,"width":259,"blurWidth":0,"blurHeight":0};